import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { getDetailUser } from '../services/users'

export const getUserDetail = createAsyncThunk('user/getUserDetail', async (userId) => {
  const params = {
    include:
    'items,invoices,platforms,parents,childs,codes,verificationStatus,documentVerification,addresses,memberships,payments,supplier,updater,referralAgent,referralClient'
  }
  const response = await getDetailUser(userId, params)
  return response
})

const userDetail = createSlice({
  name: 'user_detail',
  initialState: {
    isLoadingUser: true,
    verifiedDataUser: false,
    attributes: {},
    included: {},
    relationships: {},
    general: {},
    membership: {},
    taxInfo: {},
    additionalInfo: {},
    activity: {},
    updater: {},

    orderHistory: {},
    balanceHistory: {},
    verification: {},
    childs: [],
    referralAgent: [],
    referralClient: []
  },
  reducers: {
    userDetailState: (state, action) => {
      state.isLoadingUser = action.payload.isLoadingUser
      state.verifiedDataUser = action.payload.verifiedDataUser
      state.attributes = action.payload.attributes
      state.included = action.payload.included
      state.relationships = action.payload.relationships
      state.general = action.payload.general
      state.membership = action.payload.membership
      state.taxInfo = action.payload.taxInfo
      state.additionalInfo = action.payload.additionalInfo
      state.activity = action.payload.activity
      state.updater = action.payload.updater
      state.orderHistory = action.payload.orderHistory
      state.balanceHistory = action.payload.balanceHistory
      state.verification = action.payload.verification
      state.childs = action.payload.childs
      state.referralAgent = action.payload.referralAgent
      state.referralClient = action.payload.referralClient
    },
    updateDefaultStateUser: (state, action) => {
      state.attributes = action.payload
      state.included = action.payload
      state.relationships = action.payload
    },
    updateGeneralUser: (state, action) => {
      state.general = action.payload
    },
    updateMembershipUser: (state, action) => {
      state.membership = action.payload
    },
    updateTaxInfoUser: (state, action) => {
      state.taxInfo = action.payload
    },
    updateAdditionalInfoUser: (state, action) => {
      state.additionalInfo = action.payload
    },
    updateActivityUser: (state, action) => {
      state.activity = action.payload
    },
    updateUpdaterUser: (state, action) => {
      state.updater = action.payload
    },
    updateOrderHistoryUser: (state, action) => {
      state.orderHistory = action.payload
    },
    updateBalanceHistoryUser: (state, action) => {
      state.balanceHistory = action.payload
    },
    updateVerificationUser: (state, action) => {
      state.verification = action.payload
    },
    updateChilds: (state, action) => {
      state.childs = action.payload
    },
    updateReferralAgent: (state, action) => {
      state.referralAgent = action.payload
    },
    updateReferralClient: (state, action) => {
      state.referralClient = action.payload
    }
  },
  extraReducers: {
    [getUserDetail.pending]: (state) => {
      state.isLoadingUser = true
    },
    [getUserDetail.fulfilled]: (state, action) => {
      state.attributes = action.payload.data.attributes
      state.included = action.payload.included
      state.relationships = action.payload.data.relationships
      state.general = mappingUserGeneral(action.payload)
      state.membership = mappingUserMembership(action.payload)
      state.taxInfo = mappingUserTax(action.payload)
      state.additionalInfo = mappingUserAdditionalInfo(action.payload)
      state.activity = mappingUserActivity(action.payload)
      state.balanceHistory = mappingUserBalanceHistory(action.payload)
      state.verification = mappingUserVerification(action.payload)
      state.updater = mappingUserUpdater(action.payload)
      state.childs = handleUserRelations(action.payload, 'childs', 'referral')
      state.referralAgent = handleUserRelations(action.payload, 'referralAgent', 'sub agent')
      state.referralClient = handleUserRelations(action.payload, 'referralClient', 'client')
      // state.orderHistory = setOrderHistory(action.payload)
      state.verifiedDataUser = true
      state.isLoadingUser = false
    },
    [getUserDetail.rejected]: (state) => {
      state.verifiedDataUser = false
      state.isLoadingUser = false
    }
  }
})

function handleIncludeRelation(relationships, included, key) {
  if (relationships[key].length > 0) {
    const _array = relationships[key].map(e => {
      return included[key][e.id].attributes
    })
    return _array
  } else {
    return []
  }
}

function includedDataRelation(relationships, included, key, referralType) {
  if (relationships[key].length > 0) {
    const remapData = relationships[key].map(e => {
      const dataUser = Object.values(included[key])
      const findUser = dataUser.find(user => user.id === e.id)
      return {
        ...findUser.attributes,
        relation: referralType
      }
    })

    return remapData
  } else {
    return []
  }
}

const mappingUserGeneral = (payload) => {
  const { data, included } = payload
  const { attributes, relationships } = data

  return {
    id: attributes.id,
    fullName: attributes.name,
    countrySignup: attributes.country_signup,
    citySignup: attributes.city_signup,
    email: attributes.email,
    phone: attributes.phone,
    canOrder: attributes.can_order,
    referralCode: attributes.referral_code,
    active: attributes.active,
    survey: attributes.survey,
    markingCode: handleIncludeRelation(relationships, included, 'codes'),
  }
}

const mappingUserMembership = (payload) => {
  const { data, included } = payload
  const { attributes, relationships } = data

  const listMemberships = (memberships) => {
    const convertToArray = memberships ? Object.values(memberships) : []
    const getMembershipNameOnly = convertToArray.flatMap((value) => {
      return value.attributes.name
    })

    return getMembershipNameOnly
  }

  return {
    memberships: listMemberships(included.memberships),
    startDate: attributes.membership ? attributes.membership.start_at : '',
    expiredDate: attributes.membership ? attributes.membership.expired_at : '',
    countryCatalog: attributes.country_catalogs,
    activeCountry: attributes.country_catalog_active,
    referredBy: '',
    shippingUser: attributes.shipping_list ? attributes.shipping_list.map(e => +e) : [],
    defaultShippingToCountry: attributes.shipping_list_names,
    currency: 'IDR',
    isAgent: attributes.is_agent,
    isPartner: attributes.is_partner,
    isFulfillmentClient: attributes.is_fulfillment_client,
    notify: true,
    settings: handleIncludeRelation(relationships, included, 'settings'),
  }
}

const mappingUserTax = (payload) => {
  const { data } = payload
  const { attributes } = data
  return {
    // tax
    typeOfBussines: attributes.extras ? attributes.extras.type_of_bussines : '',
    idNumberType: '',
    type: '',
    identityCard:  attributes.extras ? attributes.extras.identity_card : '',
    registeredVat:  attributes.extras ? attributes.extras.registered_vat : '',
    taxName: attributes.extras ? attributes.extras.taxes_name : '',
    taxId: attributes.extras ? attributes.extras.taxes_id : '',
    taxAddress: attributes.extras ? attributes.extras.taxes_address : '',
    companyId: attributes.company ? attributes.company.id : '',
    companyName: attributes.company ? attributes.company.name : '',
    country: attributes.company ? attributes.company.country_id : '',
    companyLogo: attributes.company ? attributes.company.logo : '',
  }
}

const mappingUserAdditionalInfo = (payload) => {
  const { data, included } = payload
  const { attributes, relationships } = data
  return {
    // additional info
    addressInformation: handleIncludeRelation(relationships, included, 'addresses'),
    withdrawal: {
      method: attributes.extras ? attributes.extras.withdraw_method : '',
      bankName: attributes.extras ? attributes.extras.withdraw_provider : '',
      bankAccountNumber: attributes.extras ? attributes.extras.withdraw_account_number : '',
      bankAccountName: attributes.extras ? attributes.extras.withdraw_account_name : '',
      bankSwiftCode: attributes.extras ? attributes.extras.withdraw_swift_code : '',
    },
  }
}

const mappingUserActivity = (payload) => {
  const { data } = payload
  const { attributes } = data
  return {
    // activity
    lastLogin: attributes.last_login,
    lastSession: attributes.last_session,
    accountCreation: attributes.created_at,
  }
}

const mappingUserBalanceHistory = (payload) => {
  const { data, included } = payload
  const { attributes, relationships } = data
  const remap = {
    // balance history
    balance: attributes.balance,
    signupcountry: included.signupcountry[relationships?.signupcountry?.id]?.attributes || {},
    supplierList: included.supplier ? Object.values(included.supplier) : [],
  }

  if (included.payments.length !== 0) {
    const lastIndexPayment = relationships.payments.length - 1
    const valuePayment = Object.values(included.payments)
    remap.payments = valuePayment[lastIndexPayment].attributes
  } else {
    remap.payments = {
      withdraw_platform: '-',
      remarks: '-',
      value: '-',
    }
  }
  return remap
}

const mappingUserVerification = (payload) => {
  const { included } = payload
  
  const data = {}

  // set statuses
  if (included.verificationStatus.length === 0) {
    data.idStatuses = 50
    data.nameStatuses = 'unverified'
  } else {
    const __statusesToArray = Object.values(included.verificationStatus)
    data.idStatuses = __statusesToArray[0].attributes.id
    data.nameStatuses = __statusesToArray[0].attributes.name
  }

  // set image dokumen
  if (included.documentVerification.length === 0) {
    data.imageIdentity = null
    data.documen_id = null
    data.imageSelfieIdentity = null
    data.additional_document_id = null
  } else {
    const __documentIdentityToArray = Object.values(included.documentVerification)

    const filterIdentity = __documentIdentityToArray.filter((value) => value.attributes.name === 'ktp')
    const filterIdentitySelfie = __documentIdentityToArray.filter((value) => value.attributes.name === 'selfie')

    data.imageIdentity = filterIdentity.length === 0 ? null : filterIdentity[filterIdentity.length - 1].attributes.url
    data.documen_id = filterIdentity.length === 0 ? null : filterIdentity[filterIdentity.length - 1].attributes.id
    
    data.imageSelfieIdentity = filterIdentitySelfie.length === 0 ? null : filterIdentitySelfie[filterIdentitySelfie.length - 1].attributes.url
    data.additional_document_id = filterIdentitySelfie.length === 0 ? null : filterIdentitySelfie[filterIdentitySelfie.length - 1].attributes.id
  }
  return data
}

const mappingUserUpdater = (payload) => {
  const { data, included } = payload
  const { attributes } = data

  let remap = {}

  if (included.updater.length === 0) {
    remap.idUpdater = null
    remap.nameUpdater = null
    remap.updatedAt = null
  } else {
    remap.idUpdater = attributes.updated_by
    remap.nameUpdater = included.updater[attributes.updated_by].attributes.name
    remap.updatedAt = attributes.updated_at
  }

  return remap
}

const handleUserRelations = (payload, key, type) => {
  const { data, included } = payload
  const { relationships } = data
  return includedDataRelation(relationships, included, key, type)
}

export const {
  userDetailState,
  updateDefaultStateUser,
  updateGeneralUser,
  updateMembershipUser,
  updateTaxInfoUser,
  updateAdditionalInfoUser,
  updateActivityUser,
  updateUpdaterUser,
  updateOrderHistoryUser,
  updateBalanceHistoryUser,
  updateVerificationUser,
  updateChilds,
  updateReferralAgent,
  updateReferralClient
} = userDetail.actions
export default userDetail.reducer